import { UserRole } from "../../constants/user";
import { IServiceItems } from "../reports/types";

interface IErrorsType {
  name?: string[];
  email?: string[];
  password?: string[];
  passwordConfirmation?: string[];
}

export interface IError {
  errors: IErrorsType;
  title: string;
  status: string;
}

export interface IErrorCsvData {
  errors: { [k: string]: string[] };
  title: string;
}

export interface IBaseInterfaces {
  id: string;
  name: string;
  type: string;
}

export enum Order {
  Asc = "Asc",
  Desc = "Desc",
}

export interface IParams {
  searchQuery?: string;
  sort?: string;
  start?: number;
  order?: Order;
  role?: UserRole;
  stateDesignationId?: string;
  officeId?: string;
  credentials?: string;
  size?: number;
}

export interface ISplineChartService
  extends Pick<
    IServiceItems,
    "gridItems" | "charPercentage" | "totalCount" | "chartCount"
  > {
  chartItems: number[];
}
